import { selectMyTraderaItemsState } from '../reducers/my-tradera-items';
import { selectCookiesState } from 'tradera-apps/my-tradera/app/state/reducers/cookies';
import { selectMyTraderaState } from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';
import { selectRouterState } from 'tradera-apps/my-tradera/app/state/selectors/router';
import { getActionsForPurchaseOrder } from '../selectors/purchase-actions';

export const selectPurchaseOrderState = state => {
    const listViewType = selectCookiesState(state).LIST_VIEW_TYPE;
    const memberMessagingParticipation = selectMyTraderaState(state)
        .memberMessagingParticipation;
    const pageName =
        selectMyTraderaState(state).page &&
        selectMyTraderaState(state).page[
            selectRouterState(state).location.pathname
        ]?.pageName;

    const purchaseOrders = state.views.myTradera.purchaseOrder.purchaseOrders.map(
        purchaseOrder => {
            const rows = selectMyTraderaItemsState(state).itemsOrderedByID.map(
                id => {
                    return state.views.myTradera.myTraderaItems.itemsByID[id];
                }
            );
            return {
                ...purchaseOrder,
                actions: getActionsForPurchaseOrder(
                    purchaseOrder,
                    listViewType,
                    memberMessagingParticipation,
                    pageName
                ),
                rows: rows.filter(
                    row =>
                        row.transaction.purchaseOrderId ===
                        purchaseOrder.purchaseOrderId
                )
            };
        }
    );
    return {
        ...state.views.myTradera.purchaseOrder,
        purchaseOrders
    };
};
